<template>
  <div :class="$style.card">
    <img :class="$style.logo" :src="product.logo" :style="{height: `${logoHeight}px`}">
    <div :class="$style.title" data-title>{{ product.title }}</div>
    <div :class="$style.intro">{{ product.intro1 }}</div>
    <div :class="[$style.intro, $style.intro2]" v-if="product.intro2">{{ product.intro2 }}</div>
    <div class="button-orange" :class="$style.btn" @click="jump">访问官网</div>
  </div>
</template>

<script>
export default {
  props: {
    product: Object,
    logoHeight: {
      type: Number,
      default: 38
    }
  },
  created () {

  },
  destroyed () {
  },
  methods: {
    jump () {
      window.open(this.product.link)
    }
  }
}
</script>

<style lang="scss" module>
.card {
  width: 540px;
}

.title {
  margin-top: 32px;
  line-height: 45px;
  font-size: 32px;
  font-weight: 500;
  color: #333333;
  white-space: nowrap;
}

.intro {
  margin-top: 16px;
  line-height: 28px;
  font-size: 16px;
  font-weight: 400;
  color: #404040;
}

.intro2 {
  margin-top: 15px;
}

.btn {
  margin-top: 32px;
}
</style>
